var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('view-dialog',{attrs:{"css-class":"pdf-view","title":_vm.pdfName,"visible":_vm.showDialog}},[_c('div',[_c('iframe',{staticStyle:{"border":"0px"},attrs:{"src":_vm.pdfUrl,"width":"100%","height":"600"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }